import { render, staticRenderFns } from "./OtherIn.vue?vue&type=template&id=6fc637a7&scoped=true"
import script from "./OtherIn.vue?vue&type=script&lang=js"
export * from "./OtherIn.vue?vue&type=script&lang=js"
import style0 from "./OtherIn.vue?vue&type=style&index=0&id=6fc637a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc637a7",
  null
  
)

export default component.exports